export default __webpack_public_path__ + "static/media/image-cover.c406fb56.png";